import React from "react";

// The groups the subsidiary-ledger endpoint can return, in the order it returns
// them. Anything else in the payload is ignored.
const GROUPS = [
  "hr",
  "vendor",
  "distributor",
  "customer",
  "asset",
  "subsidiary",
];

/**
 * react-select options for one chart of account's subsidiary ledgers.
 *
 * The value has to stay "<group>_<ledgerId>[_<entityId>]", because the journal
 * voucher controller splits it back apart on the underscore to work out which
 * column the line belongs in.
 */
export const subCategoryOptions = (data) => {
  const options = [];

  if (!data || typeof data !== "object") return options;

  Object.keys(data).forEach((group) => {
    if (!GROUPS.includes(group)) return;

    const entries = data[group];
    if (!entries || typeof entries !== "object") return;

    Object.keys(entries).forEach((key) => {
      options.push({ value: group + "_" + key, label: entries[key] });
    });
  });

  return options;
};

const SubCategory = (props) => {
  let options = [];
  
  console.log('SubCategory received data:', props.data);
  
  if (props.data != undefined && Object.keys(props.data).length > 0) {
    options.push({ value: "", info: "Select Sub Category Module" });
    Object.keys(props.data).forEach((key) => {
      if (props.data[key] && typeof props.data[key] === 'object') {
        Object.keys(props.data[key]).forEach((info) => {
          if (key == "hr") {
            options.push({
              value: "hr_" + info,
              info: props.data[key][info],
              selected: props.selected,
            });
          } else if (key == "vendor") {
            options.push({
              value: "vendor_" + info,
              info: props.data[key][info],
              selected: props.selected,
            });
          } else if (key == "distributor") {
            options.push({
              value: "distributor_" + info,
              info: props.data[key][info],
              selected: props.selected,
            });
          } else if (key == "customer") {
            options.push({
              value: "customer_" + info,
              info: props.data[key][info],
              selected: props.selected,
            });
          } else if (key == "asset") {
            options.push({
              value: "asset_" + info,
              info: props.data[key][info],
              selected: props.selected,
            });
          } else if (key == "subsidiary") {
            options.push({
              value: "subsidiary_" + info,
              info: props.data[key][info],
              selected: props.selected,
            });
          }
        });
      }
    });
  } else {
    options.push({
      value: "",
      info: "No Sub Category Found",
      selected: null,
    });
  }
  console.log('SubCategory options generated:', options);
  return (
    <>
      {options.map((item, index) => (
        <option
          value={item.value}
          key={index}
          selected={item.value == item.selected ? true : false}
        >
          {item.info}
        </option>
      ))}
    </>
  );
};

export default SubCategory;
